import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, useMediaQuery } from '@mui/material';

import { PropsWithChildren } from 'react';
import { device } from 'src/constants/mediaQueries';
import { DescriptionHeader, TextContainer } from './styles';

type ErrorMessageProps = PropsWithChildren<{
  header: string;
  icon: IconDefinition;
}>;

export function ErrorMessage({ header, icon, children }: ErrorMessageProps) {
  const isMobile = useMediaQuery(device.mobileOrTablet);

  return (
    <StyledErrorMessageContainer role="alert">
      <FontAwesomeIcon icon={icon} size={isMobile ? /* istanbul ignore next */ '3x' : '5x'} color="#F64F46" />
      <TextContainer margin>
        <DescriptionHeader error>{header}</DescriptionHeader>
        {children}
      </TextContainer>
    </StyledErrorMessageContainer>
  );
}

const StyledErrorMessageContainer = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
`;
